export const WHEEL_PALETTE: { background: string, text: string }[] = [
    { background: '#2a58a6', text: '#ffffff' },
    { background: '#face0c', text: '#000000' },
    { background: '#3fbcc4', text: '#000000' },
    { background: '#ed3c25', text: '#ffffff' },
];
